import classNames from 'classnames';
import React from 'react';
import Container from '../container/Container';
export default (function (_a) {
    var className = _a.className, children = _a.children;
    return React.createElement(Container, { className: classNames('elevate-1', 'p-2', className) }, children);
});
